<template>
    <v-container max-width="100%" style="margin-top: 2%">

        <v-container class="toolbar__container">
            <v-form ref="form">
                <v-row>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker :label="$t('datetime.startDate')" v-model="dti" :time-picker-props="timeProps"
                            :text-field-props="textFieldProps" :date-picker-props="dtiProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-datetime-picker :label="$t('datetime.finalDate')" v-model="dtf" :time-picker-props="timeProps"
                            :text-field-props="textFieldProps" :date-picker-props="dtfProps" time-format="HH:mm:ss"
                            date-format="dd/MM/yyyy" :clear-text="$t('datetime.close')">
                            <template slot="dateIcon">
                                <v-icon>mdi-calendar</v-icon>
                            </template>
                            <template slot="timeIcon">
                                <v-icon>mdi-clock</v-icon>
                            </template>
                        </v-datetime-picker>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <LazySelect
                            get-url="getUnidadeslazy"
                            text="descricao_unidade"
                            value="id_unidade"
                            :label="$t('nav.registration.units')"
                            @input="unidadeSelecionada = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <LazySelect
                            get-url="getGruposlazy"
                            text="nome"
                            value="id_grupo"
                            :label="$t('nav.registration.groups')"
                            @input="grupoSelecionado = $event"
                        />
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                        <v-select :items="statusOptions" v-model="statusSelecionado" item-text="text"
                            item-value="value" :label="$t('qrcodeAutoSendReport.status')" clearable />
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="populaRelatorio" style="margin-bottom: 5px;">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('operation.search') }}</span>
                        </v-tooltip>
                    </v-col>
                    <v-col cols="12" sm="1" md="1" align="end">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small fab color="primary darken-1" class="white--text" v-bind="attrs" v-on="on"
                                    @click="abreCiclos" style="margin-bottom: 5px;">
                                    <v-icon>mdi-history</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ $t('qrcodeAutoSendReport.cycles.title') }}</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>

        <MerusDataTable :headers="tableHeaders" :items="situacoesFiltered" :loading="loading"
            :default-multi-sort="defaultSort" :loading-text="$t('qrcodeAutoSendReport.loading')"
            cod-tabela="RELENVIOAUTOMATICOQRCODE" @update:headers="headers = $event">
            <template v-slot:toolbar>
                <CadastroToolbar :title="$t('qrcodeAutoSendReport.title')" :token="token" :items="situacoesFiltered"
                    csv-title="envioautomaticoqrcode" :pdf-title="$t('qrcodeAutoSendReport.title')"
                    :pdf-headers="tableHeaders" pdf-filename="envioautomaticoqrcode" hide-search>
                </CadastroToolbar>
            </template>
            <template v-slot:item.status_extenso="{ item }">
                <span :class="corStatus(item.status)">{{ item.status_extenso }}</span>
            </template>
            <template v-slot:item.ultimo_erro="{ item }">
                <span class="error--text">{{ item.ultimo_erro }}</span>
            </template>
        </MerusDataTable>

        <!-- Ciclos da rotina: o campo `resumo` é o mesmo log resumido gravado pelo
             monitor, exposto aqui sem dar acesso ao filesystem do servidor. -->
        <v-dialog v-model="ciclosDialog" max-width="1100">
            <v-card>
                <v-card-title>{{ $t('qrcodeAutoSendReport.cycles.title') }}</v-card-title>
                <v-card-text>
                    <v-data-table :headers="ciclosHeaders" :items="ciclos" :loading="loadingCiclos"
                        dense :items-per-page="10">
                        <template v-slot:item.acoes="{ item }">
                            <v-btn icon small @click="resumoSelecionado = item.resumo">
                                <v-icon small>mdi-text-box-outline</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                    <v-divider v-if="resumoSelecionado" class="my-3"></v-divider>
                    <pre v-if="resumoSelecionado" class="resumo__pre">{{ resumoSelecionado }}</pre>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="ciclosDialog = false">{{ $t('datetime.close') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-container>
</template>

<script>
import apiController from '@/utils/apiController';
import MerusDataTable from "../components/Tables/MerusDataTable.vue";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import DateUtils from '@/utils/dateutils';
import LazySelect from './Selects/LazySelect.vue';

// Espelham os status gravados por monitor/envia_qrcode_pessoas.py.
const STATUS_ENVIADO = 1;
const STATUS_FALHA = 2;
const STATUS_ESGOTADO = 3;
// 6 = atendido antes da rotina (marcação de virada), nunca gravado pela rotina.
const STATUS_PRE_EXISTENTE = 6;
// 4 = falta dado no cadastro; acionável, por isso destacado como erro.
const STATUS_ERRO_CADASTRO = 4;

export default {
    components: {
        MerusDataTable,
        CadastroToolbar,
        LazySelect,
    },
    data: () => ({
        headers: [],
        user: null,
        token: null,
        unidadeSelecionada: null,
        grupoSelecionado: null,
        statusSelecionado: null,
        situacoes: [],
        ciclos: [],
        ciclosDialog: false,
        resumoSelecionado: null,
        loading: false,
        loadingCiclos: false,
        dti: null,
        dtf: null,
        config: null,
        timeProps: {
            useSeconds: true,
        },
    }),
    computed: {
        defaultSort() {
            return [
                { value: 'dt_ultima_tentativa_extenso', options: { text: this.$t('routs.decreasing'), value: -1 } }];
        },
        defaultHeaders() {
            const col = (key, value) => ({
                text: this.$t(`qrcodeAutoSendReport.headers.${key}`),
                value,
                sortable: true,
                filtrable: true,
                show: true,
            });
            return [
                col('registration', 'matricula'),
                col('name', 'nome_completo'),
                col('email', 'email'),
                col('unit', 'cod_unidade'),
                col('group', 'nome_grupo'),
                col('shift', 'cod_turno'),
                col('sendType', 'tipo_envio_extenso'),
                col('status', 'status_extenso'),
                col('attempts', 'tentativas'),
                col('lastAttempt', 'dt_ultima_tentativa_extenso'),
                col('nextAttempt', 'dt_proxima_tentativa_extenso'),
                col('method', 'metodo_extenso'),
                col('lastError', 'ultimo_erro'),
            ];
        },
        tableHeaders() {
            return this.headers.length > 0 ? this.headers : this.defaultHeaders;
        },
        ciclosHeaders() {
            const col = (key, value) => ({
                text: this.$t(`qrcodeAutoSendReport.cycles.${key}`),
                value,
            });
            return [
                col('start', 'dt_inicio_extenso'),
                col('end', 'dt_fim_extenso'),
                col('method', 'metodo_extenso'),
                col('eligible', 'n_elegiveis'),
                col('sent', 'n_ok'),
                col('failed', 'n_erro'),
                col('exhausted', 'n_esgotados'),
                col('skippedReason', 'motivo_pulada'),
                col('finished', 'concluida_extenso'),
                { text: '', value: 'acoes', sortable: false },
            ];
        },
        statusOptions() {
            return [
                { text: this.$t('qrcodeAutoSendReport.statusPending'), value: 0 },
                { text: this.$t('qrcodeAutoSendReport.statusSent'), value: STATUS_ENVIADO },
                { text: this.$t('qrcodeAutoSendReport.statusFailed'), value: STATUS_FALHA },
                { text: this.$t('qrcodeAutoSendReport.statusExhausted'), value: STATUS_ESGOTADO },
                { text: this.$t('qrcodeAutoSendReport.statusDataError'), value: 4 },
                { text: this.$t('qrcodeAutoSendReport.statusQueued'), value: 5 },
                { text: this.$t('qrcodeAutoSendReport.statusPreExisting'), value: 6 },
            ];
        },
        situacoesFiltered() {
            let dados = this.situacoes;

            if (this.unidadeSelecionada) {
                dados = dados.filter((d) => d.id_unidade === this.unidadeSelecionada);
            }
            if (this.grupoSelecionado) {
                dados = dados.filter((d) => d.id_grupo === this.grupoSelecionado);
            }
            if (this.statusSelecionado !== null && this.statusSelecionado !== undefined && this.statusSelecionado !== '') {
                dados = dados.filter((d) => Number(d.status) === Number(this.statusSelecionado));
            }

            return dados;
        },
        textFieldProps() {
            return { prependInnerIcon: "mdi-calendar" };
        },
        today() {
            return new Date().toISOString().substring(0, 10);
        },
        dtiProps() {
            return { max: this.today };
        },
        dtfProps() {
            let min = null;
            if (this.dti) {
                if (typeof this.dti === 'string') {
                    min = `${this.dti.substring(6, 10)}-${this.dti.substring(3, 5)}-${this.dti.substring(0, 2)}`;
                } else {
                    min = this.dti.toISOString().substring(0, 10);
                }
            }
            return { min: min };
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
        }
    },
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.initialize();
    },
    methods: {
        initialize() {
            this.getConfig();
        },
        corStatus(status) {
            if (Number(status) === STATUS_ENVIADO) return 'success--text';
            if (Number(status) === STATUS_PRE_EXISTENTE) return 'grey--text text--darken-1';
            if (Number(status) === STATUS_ESGOTADO) return 'error--text';
            if (Number(status) === STATUS_ERRO_CADASTRO) return 'error--text';
            if (Number(status) === STATUS_FALHA) return 'warning--text';
            return '';
        },
        getConfig() {
            apiController.request(apiController.endpoints.getallConfig, {
                onSuccess: (response) => {
                    this.config = response.data[0];
                    [this.dti, this.dtf] = DateUtils.setDefaultDateFilters(this.config.hora_inicial_dia_operacao);
                }
            });
        },
        populaRelatorio() {
            if (!this.dti || !this.dtf) {
                return;
            }
            this.loading = true;
            apiController.request(apiController.endpoints.getSituacaoenvioqrcode, {
                query: {
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                },
                onSuccess: (response) => {
                    this.situacoes = response.data;
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                }
            });
        },
        abreCiclos() {
            if (!this.dti || !this.dtf) {
                return;
            }
            this.ciclosDialog = true;
            this.resumoSelecionado = null;
            this.loadingCiclos = true;
            apiController.request(apiController.endpoints.getCorridasenvioqrcode, {
                query: {
                    dti: DateUtils.getDateSQLFormatted(this.dti),
                    dtf: DateUtils.getDateSQLFormatted(this.dtf),
                },
                onSuccess: (response) => {
                    this.ciclos = response.data;
                    this.loadingCiclos = false;
                },
                onError: () => {
                    this.loadingCiclos = false;
                }
            });
        },
    }
}
</script>

<style scoped>
.resumo__pre {
    white-space: pre-wrap;
    word-break: break-word;
    font-size: 12px;
    max-height: 340px;
    overflow-y: auto;
}
</style>
